import secureApi from "../services/secureApi";


export const getProfitReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/profit", params);
  return response.data;
};

export const getTaxReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/tax", params);
  return response.data;
};

export const getPaymentReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/payments", params);
  return response.data;
};

export const getCourierReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/courier", params);

  return response.data;
};
